import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover';
import useIsMobile from '@hooks/use-is-mobile';

interface TopicLegalNameProps {
  title: string;
  text: string;
  className?: string;
}

/**
 * TopicLegalName component:
 * Truncates and show popover for long topic names
 * Shows title in collapsed mode, text in expanded mode
 */
function TopicLegalName({ title, text, className }: TopicLegalNameProps) {
  const isMobile = useIsMobile();
  const maxWidth = isMobile ? 200 : 350;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <span
          className={`block truncate cursor-pointer text-sm ${className ?? ''}`}
          style={{ maxWidth }}
          role="button"
          tabIndex={0}
        >
          {title}
        </span>
      </PopoverTrigger>

      <PopoverContent side="bottom" align="start" className="max-w-xs break-words text-sm">
        {text}
      </PopoverContent>
    </Popover>
  );
}

export default TopicLegalName;
